<template>
  <accordion ref="accordion" v-model="mostrarAccordion">
    <div slot="header">6. Contato</div>
    <div v-if="!loading">
      <unicom-linha
        style="margin-bottom: 24px"
        :class="
          indexGeral !== Object.entries(objetoInformacoes).length - 1
            ? 'linha-embaixo'
            : ''
        "
        v-for="(infoGeral, indexGeral) in Object.entries(objetoInformacoes)"
        :key="indexGeral"
      >
        <unicom-coluna
          sm="12"
          md="6"
          :class="$breakpoint.smAndDown ? 'mb-2' : ''"
        >
          <div style="display: flex; align-items: center">
            <unicom-icone :nome="titulos[indexGeral].icone" :tamanho="20" />
            <div style="padding-left: 12px">
              {{ titulos[indexGeral].texto }}:
            </div>
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="6">
          <div
            class="segunda-cor-fonte medio espacamento-vertical"
            v-for="(info, index) in Object.entries(infoGeral[1])"
            :key="index"
          >
            {{ nomeCampos[info[0]] }}
            <span class="cor-fonte medio espacamento-horizontal">
              {{ info[1] ? info[1] : " - " }}
            </span>
          </div>
        </unicom-coluna>
      </unicom-linha>
    </div>
    <unicom-spinner
      v-if="loading"
      style="min-height: 76px"
      v-show="loading"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Carregando..."
    />
  </accordion>
</template>

<script>
import DadosGeraisMixin from "../DadosGeraisMixin";

export default {
  name: "Contatos",
  mixins: [DadosGeraisMixin],
  data() {
    return {
      objetoInformacoes: {
        telefones: {
          telefone1: "",
          telefone2: "",
          fax: "",
          whatsapp: ""
        },
        emails: {
          emailPrincipal: "",
          emailSecundario: ""
        },
        site: {
          site: ""
        }
      },
      mostrarAccordion: false,
      loading: false,
      titulos: [
        {
          texto: "Telefones",
          icone: "phone"
        },
        {
          texto: "Emails",
          icone: "mail"
        },
        {
          texto: "Site",
          icone: "globe"
        }
      ],
      nomeCampos: {
        telefone1: "Telefone 1:",
        telefone2: "Telefone 2:",
        fax: "Fax:",
        whatsapp: "Whatsapp:",
        emailPrincipal: "Email principal:",
        emailSecundario: "Email secundário:",
        site: "Site:"
      }
    };
  },
  methods: {
    init() {
      if (this.iniciado) return;

      this.loading = true;
      this.sleep(150).then(() => {
        this.getContatoPrincipal(this.idRnpPrestador)
          .then(res => {
            const {
              email,
              emailSecundario,
              fax,
              faxDdd,
              site,
              telefone,
              telefoneDdd,
              telefoneSecundario,
              telefoneSecundarioDdd,
              whatsapp,
              whatsappDdd
            } = res.data;

            this.$set(this, "objetoInformacoes", {
              telefones: {
                telefone1: this.mascaraTelefoneContato(telefoneDdd, telefone),
                telefone2: this.mascaraTelefoneContato(
                  telefoneSecundarioDdd,
                  telefoneSecundario
                ),
                fax: this.mascaraTelefoneContato(faxDdd, fax),
                whatsapp: this.mascaraTelefoneContato(whatsappDdd, whatsapp)
              },
              emails: {
                emailPrincipal: email,
                emailSecundario: emailSecundario
              },
              site: {
                site: site
              }
            });

            this.iniciado = true;
          })
          .catch(() => {
            this.mostrarAccordion = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    mascaraTelefoneContato(ddd, telefone) {
      if (!ddd || !telefone) return;

      if (telefone.startsWith("0800")) {
        return this.mascaraTelefone0800(this.zeroEsquerda(ddd, 2) + telefone);
      }

      return this.mascaraTelefone(this.zeroEsquerda(ddd, 2) + telefone);
    }
  },
  watch: {
    loading() {
      if (!this.mostrarAccordion) return;

      this.$nextTick(() => {
        this.$refs.accordion.resetarAltura();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.espacamento-horizontal {
  padding-left: 8px;
}

.espacamento-vertical {
  padding-bottom: 16px;

  &:last-child {
    padding-bottom: 0px;
  }
}
</style>
